import { CreativePerformanceRO, WeeklySnapshotRangeDTO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";

export const getTopCreativePerformance = async (
  campaignId: number,
  filters: WeeklySnapshotRangeDTO
) => {
  const { data } = await apiService.get<CreativePerformanceRO[]>(
    Endpoints.Campaigns.Get.WeeklySnapshot.TopCreativePerformance(campaignId),
    {
      params: {
        yearFrom: filters.yearFrom,
        weekFrom: filters.weekFrom,
        yearTo: filters.yearTo,
        weekTo: filters.weekTo,
      },
    }
  );

  return data;
};
